import BarChart from '../../charts/barChart'
import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    filterProp: Object,
  },
  components: {
    BarChart,
  },
  data() {
    return {
      chartKey: false,
      apiService: new ApiService(),
      loading: false,
      calibrationScheduleExecuted: undefined,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      calibrationScheduleExecutedChartData: {},
      calibrationSchedule: [],
      calibrationExecuted: [],
      internalCalibrationSchedule: [],
      internalcClibrationExecuted: [],
      labels: [],
      total: 0,
      data: {
        dataByMonth: [],
      },
    }
  },
  async created() {
    this.listcalibrationScheduleExecuted()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `1.12 - Calibrações Agendadas x Executadas - Acumulado.xlsx`
      this.apiService
        .post('excel/calibrationScheduleXExecuted', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },

    async listcalibrationScheduleExecuted() {
      await this.apiService
        .post('reports/calibrationScheduleExecuted', this.filterProp)
        .then((response) => {
          this.data = response.content
        })
        .catch((err) => {})

      this.fillChartData()
    },

    fillChartData() {
      this.calibrationScheduleExecutedChartData = {
        labels: this.data.dataByMonth.map((x) => x.month),
        datasets: [
          {
            label: this.$t('Meta'),
            type: 'line',
            data: this.data.dataByMonth.map((x) => this.data.goal),
            borderColor: 'orange',
            backgroundColor: 'rgba(255,128,0,0.1)',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: this.$t('Execução total'),
            data: this.data.dataByMonth.map((x) => x.totalPercentage),
            backgroundColor: '#aaa',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: this.$t('Execução interna'),
            data: this.data.dataByMonth.map((x) => x.percentage),
            backgroundColor: '#bbcf20',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: this.$t('Execução externa'),
            data: this.data.dataByMonth.map((x) => x.externalPercentage),
            backgroundColor: '#0288d1',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
        ],
      }

      setTimeout(() => {
        this.chartKey = !this.chartKey
      }, 500)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listcalibrationScheduleExecuted()
    },
  },
}
